import { ControlledNumberInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import React from 'react';

import { CURRENCY_CHAR } from 'constants/currency';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

export const MonthlySalary: FC<IFieldFactoryProps> = (props) => {
  const { type, ...other } = props;
  const validate = useValidateOnBlur(type);

  return (
    <ControlledNumberInput
      {...other}
      name={type}
      thousandSeparator=" "
      onBlur={validate}
      postfix={CURRENCY_CHAR}
    />
  );
};
